const initialState = {};

const csvImportExportReducer = (state, action) => {
  if (typeof state === "undefined") {
    state = initialState;
  }
  switch (action.type) {
    case "GET_EXCEL_RESPONSE_SUCCESS":
      return Object.assign({}, { data: action.resp.data });
    case "GET_EXCEL_RESPONSE_ERROR":
      return Object.assign({}, state, { error: action.error.data });
    case "GET_EXCEL_RESPONSE_RESET":
      return initialState;
    case "GET_CSV_UPLOADED_AND_ERROR_FILE_SUCCESS":
      return Object.assign({}, state, {
        uploadedAndErrorFiles: action.resp?.data,
      });
    default:
      return state;
  }
};
export default csvImportExportReducer;
